export const getGuidedModeSelectionStyle = (theme) => ({
  dialogTitle: {
    m: 0,
    p: 2,
    fontSize: "32px",
    fontWeight: 400,
    textAlign: "center",
    letterSpacing: "-0.5px",
    lineHeight: "40px",
    color: "rgba(0, 0, 0, 0.87)",
  },

  description: {
    m: 0,
    px: 2,
    pb: 2,
    fontSize: "20px",
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: "28px",
    color: "rgba(0, 0, 0, 0.6)",
  },

  closeBtn: {
    position: "absolute",
    right: 8,
    top: 8,
    color: "#333",
  },

  dialogContent: (isMobile) => ({
    padding: "20px !important",
    flex: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    ...(isMobile ? { height: "100%" } : { maxHeight: "calc(100vh - 160px)" }), // fits viewport
  }),

  card: {
    padding: "20px",
    borderRadius: "5px",
    boxShadow: "0px 0px",
    border: "1px solid #0304041A",
    background: "#fff",
  },

  cardTitle: {
    marginBottom: "10px",
    fontSize: "20px",
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: "28px",
    color: "rgba(0, 0, 0, 0.87)",
  },

  cardSubtitle: {
    fontSize: "16px",
    lineHeight: "28px",
    color: "rgba(0, 0, 0, 0.6)",
    letterSpacing: 0,
  },

  submitButton: {
    border: "1px solid #0D47A1",
    backgroundColor: "#0D47A1",
    color: "white",
    borderRadius: "5px",
    marginLeft: { lg: "5px", md: "5px", xs: "0", sm: "0" },
    padding: "12px 20px 12px 20px",
  },
});
